module.exports = __webpack_public_path__ + "img/ico.f70cfad.png";